export const getUserIntials = (fullName: string) => {
  // const initials = name.match(/\b\w/g) || [];
  // return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  const sanitizedFullName = fullName?.replace(/[^a-zA-Z\s]+/g, ''); // remove all non-alphabetic characters
  const allNamesArray = sanitizedFullName?.split(' ');
  const firstName = allNamesArray?.[0];
  const lastName = allNamesArray?.[allNamesArray.length - 1];
  const firstAndLastNames = [firstName, lastName === firstName ? '' : lastName].filter(Boolean).join(' ');
  return (
    firstAndLastNames.includes(' ')
      ? firstAndLastNames.split(' ')
      : firstAndLastNames.split('').slice(0, 2)
  )
    ?.map((item: any) => item?.substring(0, 1))
    .join('')
    .substring(0, 2).toUpperCase();
}

// source: https://stackoverflow.com/a/32589289/1268350
export const titleCase = (str: string) => {
  var splitStr = str.toLowerCase().split(' ');
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(' ');
}